
import { IVZKeyValueItem } from "@/interfaces/iPageModel";
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  name: "VZKeyValue",
  inheritAttrs: false,
  props: {
    items: { type: Array as () => Array<IVZKeyValueItem>, required: true },
    showPerRow: { type: Number, required: false, default: 2 },
    separator: { type: String, required: false, default: ":" },
    showCard: { type: Boolean, required: false, default: true },
  },
  setup(props) {
    const { showPerRow, items } = toRefs(props);

    const tableItems = computed(() => {
      return Array.from(
        { length: Math.ceil(items.value.length / showPerRow.value) },
        (v, i) =>
          items.value.slice(
            i * showPerRow.value,
            i * showPerRow.value + showPerRow.value
          )
      );
    });
    return {
      tableItems,
    };
  },
});
